import React, { useState } from 'react';
import { SignupData } from '../../../pages/SignupPage';
import { XIcon } from 'lucide-react';
interface FanFormProps {
  updateDetails: (details: any) => void;
  data: SignupData;
}
const FanForm: React.FC<FanFormProps> = ({
  updateDetails,
  data
}) => {
  const [teamInput, setTeamInput] = useState('');
  const [clubInput, setClubInput] = useState('');
  const handleAddTeam = () => {
    if (teamInput.trim() !== '') {
      const currentTeams = data.profileDetails?.favoriteTeams || [];
      updateDetails({
        favoriteTeams: [...currentTeams, teamInput.trim()]
      });
      setTeamInput('');
    }
  };
  const handleRemoveTeam = (index: number) => {
    const currentTeams = [...(data.profileDetails?.favoriteTeams || [])];
    currentTeams.splice(index, 1);
    updateDetails({
      favoriteTeams: currentTeams
    });
  };
  const handleAddClub = () => {
    if (clubInput.trim() !== '') {
      const currentClubs = data.profileDetails?.fanClubs || [];
      updateDetails({
        fanClubs: [...currentClubs, clubInput.trim()]
      });
      setClubInput('');
    }
  };
  const handleRemoveClub = (index: number) => {
    const currentClubs = [...(data.profileDetails?.fanClubs || [])];
    currentClubs.splice(index, 1);
    updateDetails({
      fanClubs: currentClubs
    });
  };
  return <div className="space-y-4" data-id="element-81">
      <div data-id="element-82">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-83">
          Years Following the Sport
        </label>
        <input type="number" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" placeholder="e.g. 15" value={data.profileDetails?.experience || ''} onChange={e => updateDetails({
        experience: e.target.value
      })} data-id="element-84" />
      </div>
      <div data-id="element-85">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-86">
          Favorite Teams
        </label>
        <div className="flex" data-id="element-87">
          <input type="text" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-l-lg block w-full p-2.5" placeholder="e.g. Liverpool FC" value={teamInput} onChange={e => setTeamInput(e.target.value)} onKeyPress={e => e.key === 'Enter' && (e.preventDefault(), handleAddTeam())} data-id="element-88" />
          <button type="button" className="bg-blue-600 text-white rounded-r-lg px-4" onClick={handleAddTeam} data-id="element-89">
            Add
          </button>
        </div>
        <div className="mt-2" data-id="element-90">
          {(data.profileDetails?.favoriteTeams || []).map((team, index) => <div key={index} className="flex items-center bg-gray-100 rounded-lg px-3 py-2 mt-2" data-id="element-91">
              <span className="flex-1" data-id="element-92">{team}</span>
              <button type="button" className="text-gray-500 hover:text-red-500" onClick={() => handleRemoveTeam(index)} data-id="element-93">
                <XIcon size={16} data-id="element-94" />
              </button>
            </div>)}
        </div>
      </div>
      <div data-id="element-95">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-96">
          Fan Club Memberships
        </label>
        <div className="flex" data-id="element-97">
          <input type="text" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-l-lg block w-full p-2.5" placeholder="e.g. Liverpool Supporters Club" value={clubInput} onChange={e => setClubInput(e.target.value)} onKeyPress={e => e.key === 'Enter' && (e.preventDefault(), handleAddClub())} data-id="element-98" />
          <button type="button" className="bg-blue-600 text-white rounded-r-lg px-4" onClick={handleAddClub} data-id="element-99">
            Add
          </button>
        </div>
        <div className="mt-2" data-id="element-100">
          {(data.profileDetails?.fanClubs || []).map((club, index) => <div key={index} className="flex items-center bg-gray-100 rounded-lg px-3 py-2 mt-2" data-id="element-101">
              <span className="flex-1" data-id="element-102">{club}</span>
              <button type="button" className="text-gray-500 hover:text-red-500" onClick={() => handleRemoveClub(index)} data-id="element-103">
                <XIcon size={16} data-id="element-104" />
              </button>
            </div>)}
        </div>
      </div>
    </div>;
};
export default FanForm;